import { render } from "./ChannelOverview.vue?vue&type=template&id=644833c0"
import script from "./ChannelOverview.vue?vue&type=script&lang=js"
export * from "./ChannelOverview.vue?vue&type=script&lang=js"

import "./ChannelOverview.vue?vue&type=style&index=0&id=644833c0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__